import { useOffline } from '@/lib/hooks/useOffline';
import { limparRejeitados } from '@/lib/offline';

/**
 * Aviso persistente sobre o que o servidor recusou ao reenviar a fila.
 *
 * Um toast não serve aqui: ele some sozinho, e o que foi recusado exige uma
 * decisão de alguém — o dado ficou perdido e precisa ser redigitado. Some só
 * quando a pessoa dispensa, o que é a confirmação de que leu.
 */
export function AvisoFilaOffline() {
  const { rejeitados } = useOffline();
  if (rejeitados.length === 0) return null;

  return (
    <div
      className="note crit"
      style={{ margin: '12px 22px 0', fontSize: 12 }}
      role="alert"
      aria-live="assertive"
    >
      <b>
        {rejeitados.length} registro(s) recusado(s) ao sincronizar — precisam ser refeitos
      </b>
      <ul style={{ margin: '6px 0 8px 16px', padding: 0 }}>
        {rejeitados.map((r) => (
          <li key={r.id}>
            {r.rotulo}
            {r.ultimoErro ? ` — ${r.ultimoErro}` : ''}
          </li>
        ))}
      </ul>
      <button className="btn sm" onClick={() => limparRejeitados()}>
        Entendi, dispensar
      </button>
    </div>
  );
}
